import { ProjectCustomers } from '../../domain/project/projectCustomers/ProjectCustomers';
import { ProjectCustomersAppField } from '../../domain/project/projectCustomers/ProjectCustomersAppFields';
import { ProjectCustomersDTO } from '../../domain/project/projectCustomers/ProjectCustomersDTO';
import { ProjectCustomersEntityField } from '../../domain/project/projectCustomers/ProjectCustomersEntityField';
import {
  ProjectCustomersStopCanceledType,
  ProjectCustomersStopCompletedType,
  ProjectCustomersStopFieldType,
} from '../../domain/project/projectCustomers/ProjectCustomersFields';
import {
  ProjectCustomersAppFieldRepository,
  ProjectCustomersEntityFieldRepository,
  ProjectCustomersRepositoryDTO,
} from '../../domain/project/projectCustomers/ProjectCustomersRepositoryDTO';
import { PlanType } from '../../domain/subscription/Subscription';
import { ProjectCustomersStyleMapper } from './ProjectCustomersStyleMapper';

class ProjectCustomersMapper {
  static toDomain(props: ProjectCustomersDTO): ProjectCustomers {
    const { fields, stop_fields, stop_completed_fields, stop_canceled_fields, style } = props;

    return ProjectCustomers.create({
      fields,
      stop_fields,
      stop_completed_fields,
      stop_canceled_fields,
      style: ProjectCustomersStyleMapper.toDomain(style),
    });
  }

  static toRepository(
    projectCustomers: ProjectCustomers,
    planType: Omit<PlanType, `monkey`>
  ): ProjectCustomersRepositoryDTO {
    const removeType = <T>(field: ProjectCustomersAppField | ProjectCustomersEntityField<T>) => {
      const { type, ...rest } = field;
      return rest;
    };

    const { fields, stop_fields, stop_completed_fields, stop_canceled_fields, style } = projectCustomers;

    return {
      fields: fields.map(removeType) as ProjectCustomersAppFieldRepository[],
      stop_fields: stop_fields.map(removeType) as Array<
        ProjectCustomersEntityFieldRepository<ProjectCustomersStopFieldType>
      >,
      stop_completed_fields: stop_completed_fields.map(removeType) as Array<
        ProjectCustomersEntityFieldRepository<ProjectCustomersStopCompletedType>
      >,
      stop_canceled_fields: stop_canceled_fields.map(removeType) as Array<
        ProjectCustomersEntityFieldRepository<ProjectCustomersStopCanceledType>
      >,
      ...(planType === `kong` ? { style: ProjectCustomersStyleMapper.toRepository(style) } : {}),
    };
  }

  static toDTO(projectCustomers: ProjectCustomers): ProjectCustomersDTO {
    const { fields, stop_fields, stop_completed_fields, stop_canceled_fields } = projectCustomers;

    return {
      fields,
      stop_fields,
      stop_completed_fields,
      stop_canceled_fields,
      style: ProjectCustomersStyleMapper.toDTO(projectCustomers.style),
    };
  }
}

export default ProjectCustomersMapper;
